export enum AppView {
  Antipattern = 'Antipattern',
  AntipatternV2 = 'AntipatternV2',
  Empty = 'Empty',
  Dashboard = 'Dashboard',
  ForgotPassword = 'ForgotPassword',
  Notification = 'Notification',
  SignIn = 'SignIn',
}
